module.exports = __webpack_public_path__ + "fonts/summernote.c1a96d26.woff";